import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { NotificationHandlerDialogComponent } from '../components/dialog/notification-handler-dialog/notification-handler-dialog.component';
import { DialogInputBase} from '../models/DialogData';

@Injectable({
  providedIn: 'root'
})
export class MessageDialogService {
  constructor(private dialog: MatDialog) { }

  showInfoMessage(title: string, message: string, callback?: () => void): void {
    const dialogData = new DialogInputBase();
    dialogData.title = title;
    dialogData.message = message;
    dialogData.titleClass = 'dialog-info';
    const dialogRef = this.dialog.open(NotificationHandlerDialogComponent, {
      data: dialogData,
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(() => {
      if (callback) {
        callback();
      }
    });
  }

  showErrorMessage(title: string, message: string, callback?: () => void): void {
    const dialogData = new DialogInputBase();
    dialogData.title = title;
    dialogData.message = message;
    dialogData.titleClass = 'dialog-error'; 
    const dialogRef = this.dialog.open(NotificationHandlerDialogComponent, {
      data: dialogData,
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(() => {
      if (callback) {
        callback();
      }
    });
  }

}
